import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../app/store';
import { skillStorageUtil as storageUtil } from '../../services/storageUtil';

export const getNames = (): AppThunk<string[]> => () => {
  return storageUtil.getAllNames();
};

export const deleteBuild = (name: string): AppThunk<string[]> => () => {
  storageUtil.deleteBuild(name);
  return storageUtil.getAllNames();
};

export const loadBuild = (name: string): AppThunk => (dispatch) => {
  const build = storageUtil.getBuild(name);
  dispatch(slice.actions.loadBuildFulfilled(build));
};

const initialState: SkillLoadState = {
  visible: false
};

export interface SkillLoadState {
  visible: boolean;
}

export const slice = createSlice({
  name: 'skillLoad',
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.visible = true;
    },
    hide: (state) => {
      state.visible = false;
    },
    loadBuildFulfilled: (state, action: PayloadAction<any>) => {
      state.visible = false;
    }
  }
});

export default slice.reducer;
export const { show, hide, loadBuildFulfilled } = slice.actions;
